import type { RouteRecordRaw } from "vue-router";

const { BRAIN, SINGLE_RESEARCH_RESULT } = RouteNames;
export const assistantRoutes: RouteRecordRaw[] = [
  {
    name: BRAIN,
    path: "",
    component: () => import("@/views/assistant/AssistantView.vue"),
  },
  {
    path: "query",
    children: [
      {
        path: "",
        redirect: {
          name: BRAIN,
          query: {
            currentTab: "research",
          },
        },
      },
      {
        path: ":id",
        name: SINGLE_RESEARCH_RESULT,
        component: () => import("@/views/assistant/AssistantSingleResearch.vue"),
      },
    ],
  },
  // {
  //   path: ":scope", //account,competitor
  //   redirect: () => ({ name: BRAIN, query: { currentTab: "about" } }),
  //   children: [
  //     {
  //       path: ":platform", //website,twitter,facebook,etc
  //       name: ASSISTANT_PLATFORM,
  //       children: [
  //         {
  //           path: "",
  //           name: ASSISTANT_WEBSITE,
  //           component: () => import("@/views/assistant/AssistantPlatformDetails.vue"),
  //         },
  //         {
  //           path: ":id",
  //           name: ASSISTANT_PLATFORM_DETAILS,
  //           component: () => import("@/views/assistant/AssistantPlatformDetails.vue"),
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    path: "competitor",
    redirect: () => ({ name: BRAIN, query: { currentTab: "competitor" } }),
    children: [
      {
        path: ":key/website",
        name: RouteNames.ASSISTANT_COMPETITOR_WEBSITE,
        component: () =>
          import("@/views/assistant/AssistantCompetitorSingleResource.vue"),
      },
      {
        path: ":key/:platform/:platformKey", //twitter/:key,facebook/:key,etc
        name: RouteNames.ASSISTANT_COMPETITOR_PLATFORM,
        component: () =>
          import("@/views/assistant/AssistantCompetitorSingleResource.vue"),
      },
      {
        path: ":key",
        name: RouteNames.ASSISTANT_COMPETITOR_DETAILS,
        component: () =>
          import("@/views/assistant/AssistantCompetitorSingleResource.vue"),
      },
    ],
  },
  {
    path: "account", //website,twitter,facebook,etc
    redirect: () => ({ name: BRAIN, query: { currentTab: "social" } }),
    children: [
      {
        path: "website",
        name: RouteNames.ASSISTANT_ACCOUNT_WEBSITE,
        component: () => import("@/views/assistant/AssistantAccountSingleResource.vue"),
      },
      {
        path: ":platform/:key", //twitter/:key,facebook/:key,etc
        name: RouteNames.ASSISTANT_ACCOUNT_PLATFORM,
        component: () => import("@/views/assistant/AssistantAccountSingleResource.vue"),
      },
    ],
  },
];
